"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

var _Utils = require("./helpers/Utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellBPContent = function CellBPContent(props) {
  var type = props.type,
      header = props.header,
      headerText = props.headerText,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      Link = props.Link;
  var _props$data = props.data,
      public_id = _props$data.public_id,
      title = _props$data.title,
      brand = _props$data.brand,
      publisher = _props$data.publisher;

  if (!header && !(0, _Utils.validateString)(title)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  var headerContent = headerText || type;
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    width: width,
    sortable: sortable,
    sortOrder: sortOrder
  }, headerContent) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    padding: "0",
    width: width,
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, {
    offset: 0
  }, /*#__PURE__*/_react["default"].createElement(_styled.EllipsisTitle, null, /*#__PURE__*/_react["default"].createElement(Link, {
    className: "contentName",
    to: "/blueprint/content/".concat(public_id)
  }, title)), /*#__PURE__*/_react["default"].createElement(_styled.BPEntities, null, /*#__PURE__*/_react["default"].createElement(Link, {
    className: "contentName",
    to: "/blueprint/brands/".concat(brand.public_id)
  }, brand.name), "x ", /*#__PURE__*/_react["default"].createElement(Link, {
    className: "campaign",
    to: "/blueprint/publishers/".concat(publisher.public_id)
  }, publisher.name))));
};

var _default = CellBPContent;
exports["default"] = _default;

//# sourceMappingURL=CellBPContent.js.map